package com.swetdot.swetgram.ui.design

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.window.Dialog
import com.swetdot.swetgram.ui.theme.SwetgramThemeTokens

/** Shared shell for centered dialogs and action menus. */
@Composable
fun SwetDialog(
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit,
) {
    Dialog(onDismissRequest = onDismiss) {
        Column(
            modifier = modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(Radius.xl))
                .background(SwetgramThemeTokens.colors.surface)
                .padding(Space.three),
            verticalArrangement = Arrangement.Top,
            content = content,
        )
    }
}

@Composable
fun SwetConfirmDialog(
    title: String,
    body: String,
    confirmText: String,
    cancelText: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
    destructive: Boolean = true,
    busy: Boolean = false,
) {
    val colors = SwetgramThemeTokens.colors
    SwetDialog(onDismiss = onDismiss, modifier = modifier) {
        Text(title, style = MaterialTheme.typography.titleLarge, color = colors.textPrimary)
        Spacer(Modifier.height(Space.one))
        Text(body, style = MaterialTheme.typography.bodyMedium, color = colors.textSecondary)
        Spacer(Modifier.height(Space.three))
        if (destructive) {
            SwetDestructiveButton(text = confirmText, onClick = onConfirm, enabled = !busy)
        } else {
            SwetPrimaryButton(text = confirmText, onClick = onConfirm, loading = busy)
        }
        Spacer(Modifier.height(Space.one))
        SwetSecondaryButton(text = cancelText, onClick = onDismiss, enabled = !busy)
    }
}

@Composable
fun SwetDropdownMenu(
    expanded: Boolean,
    onDismiss: () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit,
) {
    DropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismiss,
        modifier = modifier,
        containerColor = SwetgramThemeTokens.colors.surface,
        shape = RoundedCornerShape(Radius.lg),
        content = content,
    )
}
